import type { DateValue } from "@/lib/resumeEditor/types";

export const MONTH_NAMES = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export function yearOptions(span = 60): string[] {
  const currentYear = new Date().getFullYear();
  const years: string[] = [];
  for (let y = currentYear + 5; y >= currentYear - span; y--) {
    years.push(String(y));
  }
  return years;
}

export function formatDateValue(value: DateValue | undefined): string {
  if (!value || (!value.month && !value.year)) return "";
  if (value.month && value.year) return `${value.month} ${value.year}`;
  return value.month || value.year;
}

export function formatDateRange(
  start: DateValue | undefined,
  end: DateValue | undefined,
  current?: boolean
): string {
  const startLabel = formatDateValue(start);
  const endLabel = current ? "Present" : formatDateValue(end);
  if (!startLabel && !endLabel) return "";
  if (startLabel && endLabel) return `${startLabel} — ${endLabel}`;
  return startLabel || endLabel;
}
